export function newId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // Only reached in very old WebViews; still unique enough for card ids.
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
